import { TimeslotsConstants } from '../constants/timeslots.constants';

export class TermsUtils {

  public static getTermClass(value): string {
    if (value < 0) {
      return 'no-available-term';
    }
    if (value === 0) {
      return 'available-term-today';
    }
    if(value === 1 || value === 2) {
      return 'available-term-tomorrow';
    }
    if(value > 2 && value <= 10) {
      return 'available-term-in-future-10-days';
    }
    return 'available-term-in-future-20-days';
  }

  public static getTermTooltip(value): string {
    let label = "";
    if (value === TimeslotsConstants.UNAVAILABLE_TIMESLOT) {
      label = "TIMESLOT_TOOLTIPS.UNAVAILABLE";
    } else if (value === TimeslotsConstants.AVAILABLE_TODAY) {
      label = "TIMESLOT_TOOLTIPS.AVAILABLE_TODAY";
    } else if (value === TimeslotsConstants.AVAILABLE_TOMORROW) {
      label = "TIMESLOT_TOOLTIPS.AVAILABLE_TOMORROW";
    } else if (value === TimeslotsConstants.AVAILABLE_DAY_AFTER_TOMORROW) {
      label = "TIMESLOT_TOOLTIPS.AVAILABLE_DAY_AFTER_TOMORROW";
    } else if (value > TimeslotsConstants.AVAILABLE_DAY_AFTER_TOMORROW) {
      label = "TIMESLOT_TOOLTIPS.AVAILABLE_TERM_IN_N_DAYS";
    }
    return label;
  }
}
